<template>
    <welcome-box>
        <password-reset>
            <template v-slot:title>
                 Password reset
            </template>
            <template v-slot:subtitle>
                Enter new password
            </template>
            <template v-slot:button-label>
                Reset Password
            </template>
        </password-reset>
    </welcome-box>
</template>

<script>
import WelcomeBox from '@/components/WelcomeBoxOld.vue';
import PasswordReset from '@/components/PasswordReset/PasswordReset.vue';

export default {
    components: {
        WelcomeBox,
        PasswordReset,
    },
};
</script>
